import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class CancelVisaService {
  async getCancelRequestDoc({ smartserviceId, conditionType }) {
    try {
      const params = qs.stringify({
        ...(smartserviceId && { smartserviceId }),
        ...(conditionType && { conditionType }),
      });
      const response = await HttpClient.get(`/api/visaform/documentrequired/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async addSmartFromCancel(body) {
    try {
      const response = await HttpClient.post(`/api/visaform/smartfromcancel/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async getSmartFormList(body) {
    try {
      const params = qs.stringify({
        ...(body && body.personalId && { personalId: body.personalId }),
        ...(body && body.smartserviceId && { smartserviceId: body.smartserviceId }),
        ...(body && body.draftId && { draftId: body.draftId }),
        ...(body && body.isRequest && { isRequest: body.isRequest }),
      });
      const response = await HttpClient.get(`/api/visaform/smartfrom/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }



  async getPartFormList(body) {
    try {
      const params = qs.stringify({
        ...(body && body.personalId && { personalId: body.personalId }),
        ...(body && body.smartserviceId && { smartserviceId: body.smartserviceId }),
      });
      const response = await HttpClient.get(`/api/visaform/partsmart/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addSmartCancel(draftId) {
    try {
      const response = await HttpClient.post(`/api/visaform/smartfrom/send`, { draftId });
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


  async getSmartFormOld({ personalId, smartserviceIdNewFrom }) {
    try {
      const params = qs.stringify({
        ...personalId && { personalId },
        ...smartserviceIdNewFrom && { smartserviceIdNewFrom },
      });
      const response = await HttpClient.get(`/api/visaform/smartfromold/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addSmartFromStatusReport(body) {
    try {
      const response = await HttpClient.post(`/api/visaform/smartfromstatusreport/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addPersonalStatusReport(body) {
    try {
      const response = await HttpClient.post(`/api/personal/add`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }


}

export default new CancelVisaService();
